import axios from '../../config/axios';
import {actions as A} from '../../constants/actions';
import {setRequestId} from '../../utils/setRequestId';
import {throwErrorByCode} from '../../utils/errors/throwErrorByCode';

export const getTranslations = language => {
  return (dispatch) => {
    dispatch({
      type: A.GET_TRANSLATIONS
    });
    setRequestId();

    return axios.get('/translations/getTranslations', {
      params: {language}
    })
      .then((response) => {
        const {data} = response.data;
        const translations = data.translation_values;
        dispatch({
          type: A.GET_TRANSLATIONS_SUCCESS,
          payload: {translations}
        })
      })
      .catch((err) => {
        dispatch({
          type: A.GET_TRANSLATIONS_FAILURE,
          payload: {errorMessage: err.message}
        })
      });
  };
};
